module.exports = __webpack_public_path__ + "static/media/student28.9356b08f.png";